"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionalAsyncStorage = void 0;
var OptionalAsyncStorage = undefined;
exports.OptionalAsyncStorage = OptionalAsyncStorage;
try {
  exports.OptionalAsyncStorage = OptionalAsyncStorage = require('@react-native-async-storage/async-storage')["default"];
} catch (e) {}